import { useState, useEffect } from "react";
//import axios from "axios";
import api from "../axios/axiosInstance";
/**
 * Hook to fetch all subjects and dynamically compute units based on selectedSubject.
 */
const useSubjectsAndUnits = (selectedSubject) => {
    const [subjects, setSubjects] = useState([]);
    const [units, setUnits] = useState([]);

    useEffect(() => {
        api
            .get(`${process.env.REACT_APP_BACKEND_URL}/grades/subjects/`, {

                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            })
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                setSubjects(data);
            })
            .catch((err) => {
                console.error("Error fetching subjects:", err);
                setSubjects([]); // fallback to empty array on error
            });
    }, []);

    useEffect(() => {
        if (!selectedSubject || !Array.isArray(subjects) || subjects.length === 0) {
            setUnits([]);
            return;
        }

        const subject = subjects.find((s) => s.id === selectedSubject);

        if (subject && Array.isArray(subject.units)) {
            setUnits(subject.units);
        } else {
            setUnits([]);
        }
    }, [selectedSubject, subjects]);

    return {
        subjects: Array.isArray(subjects) ? subjects : [],
        units: Array.isArray(units) ? units : [],
    };
};

export default useSubjectsAndUnits;
